export function reorderList(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export function reorderListBySortIndex(list, startIndex, endIndex) {
  const result = Array.from(list);

  result.splice(endIndex, 0, result.splice(startIndex, 1)[0]);

  // Clean sort indexes
  let sortIndex = 1;
  result.forEach((clip, index) => {
    result[index].sortIndex = sortIndex;
    sortIndex += 1;
  });

  return result;
}
